import { useEffect, useState } from "react";

const useDebouncedValue = (value, delay) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay);
		return () => clearTimeout(timer);
	}, [delay, value]);

	return debouncedValue;
};

export default useDebouncedValue;
